module.exports = __webpack_public_path__ + "img/ps2.2082ee35.jpg";